import { uniq, pick } from 'lodash-es'
import { objectValues } from '#app/lib/utils'
import { editionAuthorRoles } from '#entities/lib/editor/properties_per_subtype'
import type { SerializedEntity } from '#server/types/entity'

export function getEditionAuthorsUris (edition: SerializedEntity) {
  return uniq(objectValues(pick(edition.claims, editionAuthorRoles)).flat())
}
